/**
 * Pure formatting utilities.
 */

export function formatTenure(val: number | string | null | undefined): string {
  if (val == null) return '';
  const n = typeof val === 'string' ? parseFloat(val) : val;
  if (isNaN(n)) return '';
  if (n < 1) {
    const months = Math.round(n * 12);
    return months + (months === 1 ? ' month' : ' months');
  }
  const years = Math.floor(n);
  const months = Math.round((n - years) * 12);
  if (months === 0) return years + (years === 1 ? ' year' : ' years');
  return years + (years === 1 ? ' yr ' : ' yrs ') + months + (months === 1 ? ' mo' : ' mos');
}

export function formatPhoneDisplay(countryCode: string | null, localNumber: string | null, rawPhone: string | null): string {
  if (countryCode && localNumber) return `+${countryCode} ${localNumber}`;
  return rawPhone ? String(rawPhone) : '';
}

export function getPhoneDigits(countryCode: string | null, localNumber: string | null, rawPhone: string | null): string {
  if (countryCode && localNumber) return countryCode + localNumber;
  return rawPhone ? String(rawPhone).replace(/[^0-9]/g, '') : '';
}

export function titleCase(str: string | null): string {
  if (!str) return '';
  return str.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.substr(1).toLowerCase());
}

export function getInitials(name: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function getAvatarGradient(name: string | null): string {
  const gradients = [
    'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    'linear-gradient(135deg, #ec4899, #f59e0b)',
    'linear-gradient(135deg, #22c55e, #06b6d4)',
    'linear-gradient(135deg, #f97316, #ef4444)',
    'linear-gradient(135deg, #6366f1, #14b8a6)',
  ];
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) {
    hash = (name || '').charCodeAt(i) + ((hash << 5) - hash);
  }
  return gradients[Math.abs(hash) % gradients.length];
}
